<template>
  <v-menu offset-y
          :close-on-content-click="false"
          origin="center center"
          class="elevation-0"
          :nudge-bottom="14"
          :nudge-left="140"
          max-width="400"
          transition="scale-transition">
    <template v-slot:activator="{ on }">
      <v-btn icon text height="38px" width="38px" v-on="on">
        <v-badge color="primary darken-2" overlap :value="newNotifications > 0">
          <template v-slot:badge>
            <span v-if="newNotifications > 0" style="font-size: 11px">{{ newNotifications > 9 ? '+9' : newNotifications }}</span>
          </template>
          <v-icon color="white" size="23px">feather-bell</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <notification-list></notification-list>
  </v-menu>
</template>

<script>
import NotificationList from '@/components/widgets/list/NotificationList.vue'
export default {
  components: { NotificationList },
  computed: {
    newNotifications () {
      return this.$store.state.appNotifications.newNotifications
    }
  }
}
</script>
